import styled from "@emotion/styled";
import { FollowUsOnFacebook } from "scmp-sdk/components/follow-us-on-facebook";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import { fontMerriweather, fontRoboto, theme } from "shared/lib/styles";

import IconTickCircle from "./icon-tick-circle.svg";

export const StyledIconTickCircle = styled(IconTickCircle)``;

type TitleProps = {
  theme?: ThemeType;
};
export const Title = styled.div<TitleProps>`
  grid-area: Title;

  font-weight: 400;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 23px;
  text-align: center;

  ${theme.breakpoints.up("tablet")} {
    font-weight: 700;
    line-height: 25px;
    text-align: start;
  }
`;

export const IconContainer = styled.div`
  grid-area: Icon;

  inline-size: 25px;
  block-size: 25px;
  margin-block-end: 8px;
`;

export const StyledFollowUsOnFacebook = styled(FollowUsOnFacebook)`
  grid-area: FollowUsOnFacebook;

  grid-template-areas:
    "Description"
    "LikeWidget";
  grid-row-gap: 4px;
  justify-items: center;

  text-align: center;
  ${theme.breakpoints.up("tablet")} {
    justify-items: end;
    justify-self: end;

    text-align: start;
  }
`;

type CheckEmailMessageProps = {
  theme?: ThemeType;
};

export const CheckEmailMessage = styled.div<CheckEmailMessageProps>`
  grid-area: CheckEmail;

  color: #001246;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 18px;
  text-align: center;
`;

export const Container = styled.div`
  display: grid;
  grid-template:
    "Icon" min-content
    "." 20px
    "Title" min-content
    "CheckEmail" min-content
    "." 48px
    "FollowUsOnFacebook" min-content
    / fit-content(100%);
  place-items: center;
  justify-content: center;

  color: #001246;

  ${theme.breakpoints.up("tablet")} {
    grid-template:
      "Icon Title FollowUsOnFacebook" min-content
      "Icon CheckEmail FollowUsOnFacebook" min-content
      / max-content fit-content(50%) 1fr max-content;
    grid-gap: 4px 12px;
    place-items: center start;
  }
`;
